import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { SedWorkspacePage } from '@/pages/SedWorkspacePage';
import { SED_APP_CODE } from '@/lib/sed';

export const SED_APP_MANIFEST: AppManifest = {
  code: SED_APP_CODE,
  name: SED_APP_CODE,
  synonym: 'Документооборот',
  appKind: SED_APP_CODE,
  area: 'full',
  apiVersion: APPSDK_VERSION,
  permissions: ['data:read', 'files', 'nav', 'events', 'notify'],
};

function SedApp() {
  return <SedWorkspacePage />;
}

export function registerSedApp(): void {
  registerAppRenderer({
    appKind: SED_APP_CODE,
    code: SED_APP_CODE,
    title: 'Документооборот',
    Component: SedApp,
    manifest: SED_APP_MANIFEST,
  });
}
